import { createSelector } from "@ngrx/store";

import { AppState } from "../store";
import { ApiKeyState } from "./api-key.reducers";

const feature = (state: AppState) => state.apiKey;

export const apiKeySelector = createSelector(
  feature,
  (state: ApiKeyState) => state.apiKeys
);
